import { gql } from '@apollo/client'

export const GET_ALL_PROCESS_REQUESTS = gql`
  query GetAllProcessesRequests(
    $searchQuery: String
    $limit: Int
    $offset: Int
    $filter: filterRequest
  ) {
    getAllProcessesRequests(
      searchQuery: $searchQuery
      limit: $limit
      offset: $offset
      filter: $filter
    ) {
      count
      rows {
        id
        folio
        external_folio
        status_id
        citizen_id
        process_id
        request_date
        request_date_end
        ProcessesRequestsToCitizens {
          id
          name
          last_name
          email
          phone
          address_full
          coordinates
        }
        ProcessesRequestsToProcesses {
          id
          name
          key
        }
        ProcessesRequestsToCategories {
          id
          name
        }
        ProcessesRequestsToSubCategories {
          id
          name
        }
        ProcessesRequestsToStatus {
          id
          name
          description
          progress
          color
          order
        }
        ProcessesRequestToSubCategoriesChildren {
          id
          name
        }
      }
    }
  }
`

export const GET_ONE_PROCESS_REQUEST_BY_ID = gql`
  query GetProcessRequestById($getProcessRequestByIdId: Int!) {
    getProcessRequestById(id: $getProcessRequestByIdId) {
      id
      folio
      external_folio
      status_id
      citizen_id
      process_id
      request_date
      request_date_end
      ProcessesRequestsToCitizens {
        id
        name
        last_name
        email
        phone
        address_full
        coordinates
        address
      }
      ProcessesRequestsToProcesses {
        id
        name
        key
      }
      ProcessesRequestsToCategories {
        id
        name
      }
      ProcessesRequestsToSubCategories {
        id
        name
      }
      ProcessesRequestToAttachments {
        id
        name
        type_file
        url
        UserOfProcessRequestAttachment {
          id
          name
          RoleOfUser {
            id
            role_name
          }
        }
      }
      ProcessesRequestsToStatus {
        id
        name
        description
        progress
        color
        order
      }
      ProcessesRequestToSubCategoriesChildren {
        id
        name
      }
    }
  }
`

export const CREATE_PROCESS_REQUESTS = gql`
  mutation CreateProcessRequest($input: inputProcessRequest!) {
    createProcessRequest(input: $input)
  }
`

export const UPDATE_PROCESS_REQUESTS = gql`
  mutation UpdateProcessRequest(
    $updateProcessRequestId: Int!
    $input: inputProcessRequest!
  ) {
    updateProcessRequest(id: $updateProcessRequestId, input: $input)
  }
`
export const CHANGE_STATUS_PROCESS_REQUESTS = gql`
  mutation ChangeStatusProcessRequest(
    $changeStatusProcessRequestId: Int!
    $input: inputChangeStatusProcessRequest
  ) {
    changeStatusProcessRequest(id: $changeStatusProcessRequestId, input: $input)
  }
`

export const DELETE_PROCESS_REQUEST = gql`
  mutation DeleteProcessRequest($id: Int!) {
    deleteProcessRequest(id: $id)
  }
`
